import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  SearchOutlined,
  ChevronLeft,
  ChevronRight,
  VisibilityOutlined,
} from "@mui/icons-material";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";

//Services
import TriplistApi from "Services/Triplist";

const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [searchText, setSearchText] = useState("");

  //Pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Get Passenger list api
  const gettriplists = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    TriplistApi.getdriversinfo({ page, limit: pageSize, search: "" })
      .then(onSuccess, onFailure);
  }, [page, pageSize, dispatch]);

  const getalltriplists = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    TriplistApi.getdriversinfo({ page: 1, limit: "unlimited", search: "" })
      .then(onSuccess, onFailure);
  }, [dispatch]);

  useEffect(() => {
    gettriplists();
    getalltriplists();
  }, [gettriplists, getalltriplists]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All KmdrivenList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const handleview = (rowData) => {
    navigate('/kmdriverreport', {
      state: {
        driverRideId: rowData.driver_ride_details._id,
        driverId: rowData._id,
      },
    });
  };

  const filteredRow = (row || []).filter((data) => {
    if (!searchText) return true;
    const searchLower = searchText.toLowerCase();
    const driverName = `${data?.firstName || ""} ${data?.lastName || ""}`.toLowerCase();
    const mobile = `${data?.countryCode || ""} ${data?.mobileNumber || ""}`.toLowerCase();
    const totalRides = (data?.ridesaccepted?.length || 0).toString();
    const kmDriven = ((data?.ridesaccepted || []).reduce(
      (sum, ride) => sum + (ride?.tripDistance ? ride?.tripDistance : 0), 0)).toString();
    const duration = ((data?.ridesaccepted || []).reduce(
      (sum, ride) => sum + (ride?.tripMinutes ? ride?.tripMinutes : 0), 0)).toString();

    return (
      driverName.includes(searchLower) ||
      mobile.includes(searchLower) ||
      totalRides.includes(searchLower) ||
      kmDriven.includes(searchLower) ||
      duration.includes(searchLower)
    );
  });

  const dataRows = _.map(filteredRow || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    drivername: (data?.firstName || "") + " " + (data?.lastName || ""),
    mobile: (data?.countryCode || "") + " " + (data?.mobileNumber || ""),
    totalrides: data?.ridesaccepted?.length || 0,
    kmdriven: (data?.ridesaccepted || []).reduce(
      (sum, ride) => sum + (ride?.tripDistance ? ride?.tripDistance : 0), 0),
    duration: (data?.ridesaccepted || []).reduce(
      (sum, ride) => sum + (ride?.tripMinutes ? ride?.tripMinutes : 0), 0),
    row: data,
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
      sno: calculateSno(page, pageSize, index),
      drivername: (data?.firstName || "") + " " + (data?.lastName || ""),
      mobile: (data?.countryCode || "") + " " + (data?.mobileNumber || ""),
      totalrides: data?.ridesaccepted?.length || 0,
      kmdriven: (data?.ridesaccepted || []).reduce(
        (sum, ride) => sum + (ride?.tripDistance ? ride?.tripDistance : 0), 0),
      duration: (data?.ridesaccepted || []).reduce(
        (sum, ride) => sum + (ride?.tripMinutes ? ride?.tripMinutes : 0), 0),
      row: data,
    }));

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Driver Name": row.drivername,
    "Mobile": row.mobile,
    "Total rides": row.totalrides,
    "Km driven": row.kmdriven.toFixed(2) + " KM",
    "Duration": row.duration.toFixed(2) + " min",
  }));

  const bulkformatteddatas = bulkdataRows.map((row) => ({
    "S.NO": row.sno,
    "Driver Name": row.drivername,
    "Mobile": row.mobile,
    "Total rides": row.totalrides,
    "Km driven": row.kmdriven.toFixed(2) + " KM",
    "Duration": row.duration.toFixed(2) + " min",
  }));

  const handleCopy = () => {
    const header = ["S.NO", "Driver Name", "Mobile", "Total Rides", "Km driven", "Duration"].join("\t");
    const rows = dataRows
      .map((r) => [r.sno, r.drivername, r.mobile, r.totalrides, r.kmdriven.toFixed(2) + " KM", r.duration.toFixed(2) + " min"].join("\t"))
      .join("\n");
    navigator.clipboard.writeText([header, rows].join("\n")).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "KmdrivenList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "KmdrivenList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno, row.drivername, row.mobile, row.totalrides, row.kmdriven.toFixed(2) + " KM", row.duration.toFixed(2) + " min",
    ]);
    doc.autoTable({
      head: [["S.NO", "Driver Name", "Mobile", "Total rides", "Km driven", "Duration"]],
      body: tableData,
    });
    doc.save("KmdrivenList.pdf");
  };

  // Pagination
  const totalPagesCount = Math.ceil(totalPages / pageSize) || 1;

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1;
    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) pages.push(i);
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [0, "...", totalPagesCount - 3, totalPagesCount - 2, totalPagesCount - 1];
      } else {
        pages = [0, "...", internalPage - 1, internalPage, internalPage + 1, "...", totalPagesCount - 1];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }
      return (
        <Button
          key={item}
          className={internalPage === item ? classes.pageButtonActive : classes.pageButton}
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  return (
    <Box className={classes.root}>
      {/* Header */}
      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>KM Driven Duration Report</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>KM Driven Duration Report</span>
        </Typography>
      </Box>

      {/* Action Row */}
      <Box className={classes.actionRow}>
        {/* Search */}
        <Box className={classes.searchWrapper}>
          <SearchOutlined className={classes.searchIcon} />
          <input
            type="text"
            placeholder="Search drivers..."
            className={classes.searchInput}
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
        </Box>

        {/* Right Actions */}
        <Box className={classes.rightActions}>
          {/* Export Group */}
          <Box className={classes.exportGroup}>
            <Button className={classes.exportButton} onClick={handleCopy}>Copy</Button>
            <Button className={classes.exportButton} onClick={handleDownloadExcel}>Excel</Button>
            <Button className={classes.exportButton} onClick={handleDownloadCSV}>CSV</Button>
            <Button className={classes.exportButton} onClick={handleDownloadPDF}>PDF</Button>
            <Button className={classes.exportButton} onClick={handleDownloadAll}>All</Button>
          </Box>
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell}>S.No</TableCell>
              <TableCell className={classes.tableHeaderCell}>Driver Name</TableCell>
              <TableCell className={classes.tableHeaderCell}>Mobile</TableCell>
              <TableCell className={classes.tableHeaderCell}>Total Rides</TableCell>
              <TableCell className={classes.tableHeaderCell}>Km Driven</TableCell>
              <TableCell className={classes.tableHeaderCell}>Duration(min)</TableCell>
              <TableCell className={classes.tableHeaderCell} align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{rowItem.sno}</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.boldText}`}>
                  {rowItem.drivername}
                </TableCell>
                <TableCell className={classes.tableCell}>{rowItem.mobile}</TableCell>
                <TableCell className={classes.tableCell}>{rowItem.totalrides}</TableCell>
                <TableCell className={classes.tableCell}>{rowItem.kmdriven.toFixed(2)} KM</TableCell>
                <TableCell className={classes.tableCell}>{rowItem.duration.toFixed(2)} min</TableCell>
                <TableCell className={classes.tableCell} align="right">
                  <Box
                    component="span"
                    className={classes.actionButton}
                    onClick={() => handleview(rowItem.row)}
                  >
                    <VisibilityOutlined fontSize="small" />
                    View
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} style={{ textAlign: "center", padding: "40px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No data found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Pagination */}
        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + (dataRows.length > 0 ? 1 : 0)} to{" "}
            {Math.min(page * pageSize, totalPages)} of {totalPages} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />
            {renderPagination()}
            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>
    </Box>
  );
};

export default Passenger;
